<template>
  <div>
    <div v-for="formelement in form" :key="formelement.key">
      <div v-if="formelement.type === 'captcha'">
        <hr/>
        <b>{{selectedDate.date | moment('dddd, DD. MMMM YYYY')}} um {{selectedDate.date | moment('HH:mm')}} Uhr</b>: {{ settings['appointmentgroup.default.frontend.message.confirm'].value }}
        <div class="row mt-3">
          <div class="col-12 col-md-12 col-sm-12 col-lg-6 col-xl-6">
            <div v-html="formelement.config.content"></div>
          </div>
          <div class="col-12 col-md-12 col-sm-12 col-lg-6 col-xl-6">
            <b-form-input @input="validateInput" :placeholder="settings['appointmentgroup.default.frontend.message.confirm.placeholder'].value" invalid-feedback="Bitte füllen Sie dieses Feld aus" :state="captchaState" v-model="captchaInput" trim></b-form-input>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { BFormInput } from 'bootstrap-vue'
export default {
  name: "FormCaptcha",
  props: ['form', 'date', 'settings'],
  components: {
    BFormInput
  },
  data() {
    return {
      selectedDate: {},
      captchaState: null,
      captchaInput: ''
    }
  },
  mounted() {
    this.selectedDate = this.date
  },
  watch: {
    date: function(date) {
      this.selectedDate = date
    }
  },
  methods: {
    validate() {
      const isValid = this.validateInput()
      return {
        userInput: this.captchaInput,
        isValid: isValid
      }
    },
    validateInput() {
      const validInput = (this.captchaInput.length == 5)
      this.captchaState = validInput
      return validInput
    },
    reset() {
      this.captchaInput = ''
      this.validateInput()
    }
  }

}
</script>

<style scoped>

</style>